<script lang="ts" setup>
  import type { LobbyView } from '../../../../shared/api/lobby.ts';
  import { userAction } from '../../../../shared/observability/userAction.ts';
  import { Button } from '../../../../shared/ui/button';
  import GameSettingsContainer from './GameSettingsContainer.vue';
  import LobbyLayout from './LobbyLayout.vue';
  import PlayersAndInvitation from './PlayersAndInvitation.vue';

  defineProps<{ data: LobbyView; error: string; showRules: boolean }>();
  defineEmits<{ startGame: []; settingsUpdated: [] }>();
</script>

<template>
  <LobbyLayout :game-code="data.gameCode" :rounds="data.gameConfig.rounds" :show-rules="showRules">
    <template #settings>
      <GameSettingsContainer
        :config="data.gameConfig"
        :phase-lengths-range="data.phaseLengthsRange"
        :rounds-range="data.roundsRange"
        @saved="$emit('settingsUpdated')"
      />
    </template>

    <PlayersAndInvitation
      :game-code="data.gameCode"
      :player="data.player"
      :players="data.players"
      :show-invite-first="data.players.length === 1"
    />

    <div class="start-action">
      <p class="error-message">{{ error }}</p>
      <Button
        :data-faro-user-action-name="userAction.lobbyStartGame"
        :disabled="!data.mayStart"
        @click="$emit('startGame')"
      >
        Start Game
      </Button>
      <p class="player-count-hint">
        <template v-if="!data.mayStart">Need at least 2 active players to start</template>
      </p>
    </div>
  </LobbyLayout>
</template>

<style scoped>
  .start-action {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: -1rem;
    max-width: var(--control-max-width);
    min-height: var(--lobby-action-height);
    width: 100%;
  }

  .error-message {
    color: var(--color-error);
    line-height: 1.5;
    margin: 0;
    min-height: 1.5rem;
    text-align: center;
  }

  .player-count-hint {
    color: var(--color-primary);
    font-size: var(--font-size-sm);
    line-height: 1.25;
    margin: 0;
    min-height: 1.25rem;
    text-align: center;
  }
</style>
